export default "__VITE_ASSET__4d6b79bb__"